import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'object_id': {
    title: '销售订单编号',
    type: 'input',
    equation: cusname,
    slot: true
  },
  'process_type': {
    describe: true,
    title: '订单类型',
    type: 'select',
    equation: city,
    dictionary: 'A0043'
  },
  'status': {
    describe: true,
    title: '订单状态',
    type: 'select',
    equation: city,
    dictionary: 'A0041'
  },
  'hk_status': {
    title: '货款校验状态',
    type: 'input'
  },
  'zy_pe_month': {
    title: '计划月度',
    type: 'input',
    width: 80
  },
  'customer': {
    title: '订单客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    },
    unSearchRole: 'WLY001'
  },
  'cust_name': {
    title: '订单客户名称',
    type: 'input',
    equation: cusname,
    width: 250,
    unSearchRole: 'WLY001'
  },
  'customer_type': {
    describe: true,
    title: '订单客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009',
    unSearchRole: 'WLY001'
  },
  'zzfld00001h': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale',
    unSearchRole: 'WLY001'
  },
  'zzfld00003e': {
    describe: true,
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base',
    unSearchRole: 'WLY001'
  },
  'number_int': {
    title: '行号',
    formatter: ({ cellValue }) => Number(cellValue),
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld00002q': {
    describe: true,
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002',
    width: 200
  },
  'ordered_prod': {
    title: '产品编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '产品编码'
    },
    width: 180
  },
  'description': {
    title: '产品描述',
    type: 'input',
    equation: cusname,
    width: 300
  },
  'zzfld00002j': {
    describe: true,
    title: '运达方类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'zzfld00002l': {
    title: '收货人联系人',
    type: 'input',
    equation: cusname
  },
  'zzfld00002m': {
    title: '收货联系人电话',
    type: 'input',
    equation: cusname,
    width: 150
  },
  'zzfld00008t': {
    title: '运达方编码',
    type: 'input',
    equation: cusname
  },
  'zzfld00008t_dscr': {
    title: '运达方名称',
    type: 'input',
    width: 250,
    equation: cusname
  },
  'zzfld00002n': {
    title: '收货地址',
    type: 'input',
    width: 300,
    equation: cusname
  },
  'zzfld00002t': {
    title: '单位',
    type: 'input',
    equation: cusname
  },
  'quantity': {
    title: '数量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld000009': {
    title: '件数',
    xlsxFmt: {
      t: 'n'
    }
  },
  'use_bot': {
    title: '瓶数',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld00002e': {
    title: '税率'
  },
  'net_price': {
    title: '含税单价',
    xlsxFmt: {
      t: 'n'
    }
  },
  'net_value': {
    title: '价税合计',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld00002a': {
    describe: true,
    title: '折扣类型',
    type: 'select',
    equation: city,
    dictionary: 'A0037'//
  },
  'zzfld00002f': {
    title: '单品折扣'
  },
  'zzfld00002g': {
    title: '折后含税单价',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld00002i': {
    title: '订单折扣额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld00002o': {
    title: '占用开票数量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld000035': {
    title: '已占用开票件数',
    width: 150,
    xlsxFmt: {
      t: 'n'
    }
  },
  'zy_bill_bot': {
    title: '已占用开票瓶数',
    width: 150,
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld000007': {
    title: '累计开票数量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld000032': {
    title: '累计开票件数',
    xlsxFmt: {
      t: 'n'
    }
  },
  'lj_bill_bot': {
    title: '累计开票瓶数',
    xlsxFmt: {
      t: 'n'
    }
  },
  'zzfld00002b': {
    title: '是否关闭',
    type: 'whether',
    equation: city
  },
  'zzfld000028': {
    title: '抬头备注',
    type: 'input',
    width: 400,
    equation: cusname
  },
  'zzfld000008': {
    title: '行备注',
    type: 'input',
    equation: cusname
  },
  'all_price': {
    title: '整单价税合计',
    xlsxFmt: {
      t: 'n'
    }
  },
  'all_quantity': {
    title: '整单数量合计',
    xlsxFmt: {
      t: 'n'
    }
  },
  'posting_date': {
    title: '创建日期',
    type: 'date',
    equation: all,
    defaultVal: new Date()
  },
  'zzfld00002d_dscr': {
    title: '创建人',
    type: 'input',
    equation: all
  },
  'reward_name': {
    title: '项目类型名称',
    type: 'input',
    equation: all
  }
}



// WEBPACK FOOTER //
// ./src/views/order-manage/config/salesOrderDetailList.js